import { LockClosedIcon } from '@heroicons/react/16/solid'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { TranslationContextProvider } from '../../../../components/discover/aivy-pdf-reports/context/general-translations'
import { useDiscover } from '../../hooks/useDiscover'
import { EVALUATION_CONTEXT } from '../../utils'
import LockedTalentSection from '../LockedTalentSection'
import TeamProfileSection from '../TeamProfileSection'

export default function ConditionalTeamProfileSection({
  teamProfile,
  career,
  className,
  selectedCareerIds,
  selectedTalentIds,
  isLoading,
  isLoadingCareer,
  lockedCount = 0,
  isStoragePending = false
}) {
  const { t } = useTranslation()
  const { selectedResult, isFlexibleMatchingEnabled } = useDiscover()

  const shouldRenderProfile =
    selectedResult === EVALUATION_CONTEXT.TEAMPROFILE &&
    selectedTalentIds.length >= 2 &&
    !isFlexibleMatchingEnabled

  if (!shouldRenderProfile) return null

  // Gesperrte Talente fließen nicht ins Teamprofil. Bleiben weniger als zwei
  // freie, gibt es kein Teamprofil, nur den Hinweis.
  const unlockedCount = selectedTalentIds.length - lockedCount
  if (!isStoragePending && lockedCount > 0 && unlockedCount < 2) {
    return (
      <LockedTalentSection
        className={className}
        variant='team'
        lockedCount={lockedCount}
      />
    )
  }

  return (
    <TranslationContextProvider data={teamProfile}>
      {!isStoragePending && lockedCount > 0 && (
        <p className='mb-2 flex items-center gap-x-1.5 text-sm text-gray-600'>
          <LockClosedIcon aria-hidden='true' className='size-4 text-gray-400' />
          {t('pricing.talent_locked.compare_locked_hint', {
            count: lockedCount
          })}
        </p>
      )}
      <TeamProfileSection
        teamProfile={teamProfile}
        career={career}
        className={className}
        selectedCareerIds={selectedCareerIds}
        isLoading={isLoading || isStoragePending}
        isLoadingCareer={isLoadingCareer}
      />
    </TranslationContextProvider>
  )
}

ConditionalTeamProfileSection.propTypes = {
  teamProfile: PropTypes.object,
  career: PropTypes.object,
  className: PropTypes.string,
  selectedCareerIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectedTalentIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  isLoading: PropTypes.bool,
  isLoadingCareer: PropTypes.bool,
  lockedCount: PropTypes.number,
  isStoragePending: PropTypes.bool
}
